export class StylesBuilder {
  constructor() {
    this.styles = []
    this.strings = []
    this.styleSheet = {
      desktop: [],
      tablet: [],
      phone: [],
    }
  }

  add(styles) {
    this.styles.push(styles)
  }

  addStylesString(stylesString) {
    this.strings.push(stylesString)
  }

  get() {
    return this.styles
  }

  build() {
    this.styles.forEach(elementStyle => {
      Object.keys(elementStyle).forEach(elementStyleProperty => {
        if (elementStyleProperty == 'id') {
          return
        }
        if (Object.prototype.hasOwnProperty.call(elementStyle[elementStyleProperty], 'phone')) {
          this.addPhoneMediaStyles(elementStyle[elementStyleProperty].phone, elementStyle.id)
        }
        if (Object.prototype.hasOwnProperty.call(elementStyle[elementStyleProperty], 'tablet')) {
          this.addTabletMediaStyles(elementStyle[elementStyleProperty].tablet, elementStyle.id)
        }
        if (Object.prototype.hasOwnProperty.call(elementStyle[elementStyleProperty], 'desktop')) {
          this.addDesktopMediaStyles(elementStyle[elementStyleProperty].desktop, elementStyle.id)
        }
      })
    })
    return this.buildStyleSheet()
  }

  buildStyleSheet() {
    let phoneString = this.styleSheet.phone.reduce((carry, deviceStyles) => carry += deviceStyles, '')
    let tabletString = this.styleSheet.tablet.reduce((carry, deviceStyles) => carry += deviceStyles, '@media (min-width: 640px) {') + '}'
    let desktopString = this.styleSheet.desktop.reduce((carry, deviceStyles) => carry += deviceStyles, '@media (min-width: 1024px) {') + '}'
    return phoneString + tabletString + desktopString + this.strings.join('')
  }

  addPhoneMediaStyles(styles, selector) {
    let elementStyles = this.parseStyles(styles, selector)
    this.styleSheet.phone.push(elementStyles)
  }

  addTabletMediaStyles(styles, selector) {
    let elementStyles = this.parseStyles(styles, selector)
    this.styleSheet.tablet.push(elementStyles)
  }

  addDesktopMediaStyles(styles, selector) {
    let elementStyles = this.parseStyles(styles, selector)
    this.styleSheet.desktop.push(elementStyles)
  }

  addGeneralStyles(styles) {
    this.styleSheet.desktop.push(styles)
  }

  parseStyles(styles, selector) {
    let elementStylesString = Object.keys(styles).reduce((carry, styleProperty) => carry + `${styleProperty}: ${styles[styleProperty]};`, '')
    if (! elementStylesString.length) {
      return ''
    }
    return `${selector}{${elementStylesString}}`
  }
}
